exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.selected[data-v-179a5ac4] {\n  background: #3139f2;\n  color: #fff;\n}\n", ""]);

// exports
